import * as AT from "src/core/users/store/users.constants";
import { IUser } from "src/core/users/api/users.api";
import { IOrderVariant } from "src/core/orders/api/orders.api";

export type UserActions = ISetUser | IPurgeUsers | ISetUserAccessibleOrderVariants;

interface ISetUser {
  type: AT.SET_USER;
  user: IUser | null;
}

export const setUser = (user: IUser | null): ISetUser => {
  return {
    type: AT.SET_USER,
    user
  };
};

interface IPurgeUsers {
  type: AT.PURGE_USERS;
}

export const purgeUsers = (): IPurgeUsers => {
  return { type: AT.PURGE_USERS };
};

interface ISetUserAccessibleOrderVariants {
  type: AT.SET_USER_ACCESSIBLE_ORDER_VARIANTS,
  accessibleOrderVariants: IOrderVariant[]
}

export const setUserAccessibleOrderVariants = (orderVariants: IOrderVariant[]): ISetUserAccessibleOrderVariants => {
  return {
    type: AT.SET_USER_ACCESSIBLE_ORDER_VARIANTS,
    accessibleOrderVariants: orderVariants
  };
};